import React from "react";

import "./RoomHeaderStyle.css";

const RoomHeader = ({ title, subtitle, icon }) => {
  return (
    <div className="header">
      <div>{icon}</div>

      <div>
        <h1 className="text-gradient-primary">{title}</h1>
        <h2>{subtitle}</h2>
      </div>
    </div>
  );
};

export default RoomHeader;
